import { memo } from 'react';

import { useAppSelector } from '~/store';
import { globalFetchingLabelSelector, isGlobalFetchingSelector } from '~/store/selectors/fetchingCounterSelectors';

import AnimatedFetchingComponent from '~/UIKit/AnimatedFetchingComponent/AnimatedFetchingComponent';

const GlobalProcessingManager = () => {
  const isFetching = useAppSelector(isGlobalFetchingSelector);
  const label = useAppSelector(globalFetchingLabelSelector);

  return <AnimatedFetchingComponent label={label} isFetching={isFetching} isGlobal />;
};

export default memo(GlobalProcessingManager);
